/* 928sRus - Route package protection, custom cart layout
   Added 2026-08-28. Thin single-row info bar, icon first, 2026-08-31.

   WHY THIS EXISTS
   Route injects its cart UI at runtime; none of it lives in the theme.
   This script relabels, restyles and reorders Route's OWN elements in
   place. It never clones or rebuilds them, so Route's click handlers and
   the protection line-item logic stay intact.

   TARGET LAYOUT
     [ Go to Checkout ]                        Route's original button
     [ Checkout w/ Package Protection ]        Route's cloned button
            +$2.15                             subtext, price read live
     [ i  More info on package protection ]    thin single-row bar,
                                               icon first via order:-1
                                               opt-out link hidden

   Selectors below come from Route's own route-checkbox-handler.js.
*/
(function () {
  'use strict';

  var CONFIG = {
    routeButton: '[data-route-cloned-button]',
    optOutLink: '.route-continue-without-coverage-link',
    scope: '#shopify-section-cart-template',

    // Route's "Your order is protected." bar has no documented class name,
    // so it is located by its text. If the dark styling lands on the wrong
    // element, put the real selector here and it will be used instead.
    infoBar: '',

    protectedText: 'your order is protected',
    buttonLabel: 'Checkout w/ Package Protection',
    infoLabel: 'More info on package protection',

    // Secondary lines Route stacks under its label. Blanked so the bar
    // stays a single thin row. Matched lowercase, as a substring.
    dropLines: ['see what\'s included', 'see whats included']
  };

  var PRICE = /[$\u20AC\u00A3]\s*\d[\d,]*(?:\.\d{2})?/;
  var busy = false;

  function styles() {
    if (document.getElementById('rus-route-css')) return;
    var s = document.createElement('style');
    s.id = 'rus-route-css';
    s.textContent =
      /* --- Route checkout button: readable label, prominent price --- */
      '[data-route-cloned-button][data-rus-btn]{line-height:1.35 !important;' +
      'font-size:15px !important;font-weight:600 !important;}' +
      '[data-rus-label]{font-size:15px !important;font-weight:600 !important;' +
      'letter-spacing:.2px !important;opacity:1 !important;}' +
      /* Price is deliberately large so the added cost is unmissable. */
      '[data-rus-price]{display:block !important;margin-top:3px !important;' +
      'font-size:15px !important;font-weight:700 !important;opacity:1 !important;}' +

      /* --- Info bar: one thin row, icon then label, centred as a pair --- */
      '[data-rus-info]{display:flex !important;flex-direction:row !important;' +
      'flex-wrap:nowrap !important;align-items:center !important;justify-content:center !important;' +
      'gap:8px !important;width:100%;margin:8px 0 0;padding:6px 12px;box-sizing:border-box;' +
      'min-height:0 !important;background:#1c1c1c !important;color:#fff !important;' +
      'border:1px solid #3a3a3a !important;border-radius:4px;cursor:pointer;' +
      /* Greys out Route's blue icon whatever paints it - fill, background or image. */
      'filter:grayscale(1) !important;}' +
      /* Route nests the label and icon several levels deep in column
         wrappers. Flatten every wrapper, not just direct children, and
         collapse the leftover height from the blanked secondary line.
         SVG and its internals are excluded so the glyph still draws. */
      '[data-rus-info] *:not(svg):not(img):not(path):not(circle):not(g){' +
      'display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;' +
      'align-items:center !important;justify-content:center !important;gap:8px !important;' +
      'margin:0 !important;padding:0 !important;min-height:0 !important;height:auto !important;' +
      'font-size:12px !important;font-weight:600 !important;line-height:1.2 !important;' +
      'color:#fff !important;background:transparent !important;border:none !important;}' +
      /* order:-1 puts the icon in front of the label without moving any
         node, so Route's click handler on the icon is untouched. */
      '[data-rus-icon]{order:-1 !important;flex:0 0 auto !important;width:auto !important;}' +
      '[data-rus-info] svg,[data-rus-info] img{width:14px !important;height:14px !important;' +
      'min-width:14px !important;min-height:14px !important;flex:0 0 auto !important;}' +
      '[data-rus-info] svg *{width:auto !important;height:auto !important;}' +

      '[data-rus-optout]{display:none !important;}';
    document.head.appendChild(s);
  }

  function textNodes(root) {
    var out = [], w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { if ((n.nodeValue || '').trim()) out.push(n); }
    return out;
  }

  /* Tag a text node's parent so CSS can target label and price separately.
     Skipped when the parent is the button itself, which would restyle the
     whole button instead of just that line. */
  function tagParent(node, attr, btn) {
    var p = node && node.parentElement;
    if (!p || p === btn) return;
    p.setAttribute(attr, '1');
  }

  /* Tag the outermost wrapper that still only holds the icon, so the icon
     can be reordered whether Route nests it or not. */
  function tagIcon(bar) {
    var icon = bar.querySelector('svg, img');
    if (!icon) return;
    var wrap = icon;
    while (wrap.parentElement && wrap.parentElement !== bar) wrap = wrap.parentElement;
    if (wrap !== bar) wrap.setAttribute('data-rus-icon', '1');
  }

  function relabelButton(btn) {
    if (btn.getAttribute('data-rus-btn') === '1') return;
    var nodes = textNodes(btn), main = null, sub = null, i, m;
    for (i = 0; i < nodes.length; i++) {
      if (PRICE.test(nodes[i].nodeValue)) sub = nodes[i];
      else if (!main) main = nodes[i];
    }
    if (main && sub) {
      main.nodeValue = CONFIG.buttonLabel;
      m = sub.nodeValue.match(PRICE);
      if (m) sub.nodeValue = '+' + m[0];
      tagParent(main, 'data-rus-label', btn);
      tagParent(sub, 'data-rus-price', btn);
    } else if (sub) {
      m = sub.nodeValue.match(PRICE);
      sub.nodeValue = CONFIG.buttonLabel + (m ? '  +' + m[0] : '');
      tagParent(sub, 'data-rus-label', btn);
    } else if (main) {
      main.nodeValue = CONFIG.buttonLabel;
      tagParent(main, 'data-rus-label', btn);
    }
    btn.setAttribute('data-rus-btn', '1');
  }

  /* Relabel the protected line, blank any secondary lines. Only text node
     values change, so Route's icon and click target survive. */
  function relabelBar(bar) {
    var nodes = textNodes(bar), labelled = false, i, j, t;
    for (i = 0; i < nodes.length; i++) {
      t = nodes[i].nodeValue.trim().toLowerCase();
      if (!labelled && t.indexOf(CONFIG.protectedText) !== -1) {
        nodes[i].nodeValue = CONFIG.infoLabel;
        labelled = true;
        continue;
      }
      for (j = 0; j < CONFIG.dropLines.length; j++) {
        if (t.indexOf(CONFIG.dropLines[j]) !== -1) { nodes[i].nodeValue = ''; break; }
      }
    }
  }

  function findInfoBar(scope, btn) {
    if (CONFIG.infoBar) return scope.querySelector(CONFIG.infoBar);

    var done = scope.querySelector('[data-rus-info]');
    if (done) return done;

    var all = scope.querySelectorAll('*'), hit = null, i, t;
    for (i = 0; i < all.length; i++) {
      t = (all[i].textContent || '').trim().toLowerCase();
      if (t.indexOf(CONFIG.protectedText) !== -1) hit = all[i];
    }
    if (!hit) return null;

    // Climb to the outermost wrapper that is still just this bar.
    while (hit.parentElement && hit.parentElement !== scope) {
      var p = hit.parentElement;
      if (btn && p.contains(btn)) break;
      if (p.querySelectorAll('*').length > 12) break;
      hit = p;
    }
    return hit;
  }

  function apply() {
    var scope = document.querySelector(CONFIG.scope) || document;
    var btn = scope.querySelector(CONFIG.routeButton);
    if (!btn) { scope = document; btn = document.querySelector(CONFIG.routeButton); }
    if (!btn) return;

    styles();
    relabelButton(btn);

    var bar = findInfoBar(scope, btn), i;
    if (bar && bar.getAttribute('data-rus-info') !== '1') {
      relabelBar(bar);
      tagIcon(bar);
      bar.setAttribute('data-rus-info', '1');
      btn.insertAdjacentElement('afterend', bar);
    }

    var optOut = scope.querySelectorAll(CONFIG.optOutLink);
    for (i = 0; i < optOut.length; i++) optOut[i].setAttribute('data-rus-optout', '1');
  }

  function run() {
    if (busy) return;
    busy = true;
    try { apply(); } catch (e) { console.warn('[928sRus] Route layout:', e); }
    busy = false;
  }

  function start() {
    run();
    if (!document.body) return;
    new MutationObserver(function () {
      window.requestAnimationFrame(run);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
